export * from './onboardingCustomerInformation.component';
export * from './onboardingCustomerInformation.service';



// WEBPACK FOOTER //
// ./src/app/OnBoardingCustomerInformation/index.ts